import api from '../../../../../api/client';
import { CASH_FLOW, CLIENT, USER } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getClients(params = {}) {
  try {
    const response = await api.get(CLIENT.CLIENTS_LIST, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getWinners(params = {}) {
  try {
    const response = await api.get(USER.WINNERS, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getCashflowDashboard(params = {}) {
  try {
    const response = await api.get(CASH_FLOW.DASHBOARD, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getCashflowEnrollment(params = {}) {
  try {
    const response = await api.get(CASH_FLOW.ENROLLMENT, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getCashflowAuctionPayment(params = {}) {
  try {
    const response = await api.get(CASH_FLOW.AUCTION_PAYMENT, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getCashflowRecharge(params = {}) {
  try {
    const response = await api.get(CASH_FLOW.RECHARGE, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getCashflowWithdrawal(params = {}) {
  try {
    const response = await api.get(CASH_FLOW.WITHDRAWAL, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getCashflowTransactions(params = {}) {
  try {
    const response = await api.get(CASH_FLOW.TRANSACTION, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getAuctionPaymentDetails(params = {}) {
  try {
    const response = await api.get(CASH_FLOW.AUCTION_PAYMENT_DETAILS, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function getClientPayOutDetails(params = {}) {
  try {
    const response = await api.get(CASH_FLOW.CLIENT_PAYOUT_DETAILS, { params });
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
